import AvatarUpload from 'components/common/AvatarUpload';
import React, { useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import team15 from 'assets/img/team/avatar.webp';
import { useSelector } from 'react-redux';
import { RootState } from 'redux-state/store';
import { currencyFormat, PF } from 'helpers/utils';
import TimeAgo from 'timeago-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faStar as faSolidStar,
  faStarHalfAlt
} from '@fortawesome/free-solid-svg-icons';
import { faStar as faRegularStar } from '@fortawesome/free-regular-svg-icons';
import VendorReviewModal from 'components/modals/VendorReviewModal';
import Button from 'components/base/Button';
import RateVendorButton from './RateVendorButton';

interface EcomDeVendorDetailsCardProps {
  vendorId: string | null;
  avatar: string | null;
  createdAt: string | null;
  productsCount: number | 0;
  totalReview: number | 0;
  fullName: string | null;
  totalRanking: number | 0;
}

const EcomVendorDetailsCard = ({
  fullName,
  avatar,
  createdAt,
  productsCount,
  totalReview,
  vendorId,
  totalRanking
}: EcomDeVendorDetailsCardProps) => {
  const { user } = useSelector((state: RootState) => state.auth);
  const [openReviewModal, setOpenReviewModal] = useState(false);

  return (
    <>
      <Card className="h-100">
        <Card.Body>
          <div className="border-bottom border-dashed pb-4">
            <Row className="align-items-center g-3 g-sm-5 text-center text-sm-start">
              <Col
                xs={12}
                sm="auto"
                className="d-flex align-items-center gap-3 flex-wrap"
              >
                <img
                  src={avatar && avatar !== '' ? PF + avatar : team15}
                  alt="User Avatar"
                  style={{
                    width: '80px',
                    height: '80px',
                    borderRadius: '50%',
                    objectFit: 'cover'
                  }}
                />
                <div>
                  <h3 className="text-capitalize mb-1">{fullName ?? ''}</h3>
                  <p className="text-body-secondary mb-0">
                    Joined {createdAt ? <TimeAgo datetime={createdAt} /> : ''}
                  </p>
                </div>
              </Col>
              <Col xs={12} sm="auto" className="ms-auto">
                <RateVendorButton vendorId={vendorId} />
              </Col>
            </Row>
          </div>
          <div className="d-flex flex-between-center pt-4">
            <div>
              <h6 className="mb-2 text-body-secondary">Total Product</h6>
              <h4 className="fs-7 text-body-highlight mb-0">{productsCount}</h4>
            </div>
            <div className="text-end">
              <h6 className="mb-2 text-body-secondary">Total Review</h6>
              <h4 className="fs-7 text-body-highlight mb-0">{totalReview}</h4>
            </div>
            <div className="text-end">
              <h6 className="mb-2 text-body-secondary">Total Ranking</h6>
              <div className="d-flex justify-content-end align-items-center gap-1">
                {[...Array(5)].map((_, i) => (
                  <FontAwesomeIcon
                    key={i}
                    icon={
                      i < Math.round(totalRanking) ? faSolidStar : faRegularStar
                    }
                    className={
                      i < Math.round(totalRanking)
                        ? 'text-warning'
                        : 'text-secondary'
                    }
                  />
                ))}
                <h4 className="fs-7 text-body-highlight mb-0">
                  ({Math.round(totalRanking)})
                </h4>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
      {user?.role === 'customer' && (
        <VendorReviewModal
          show={openReviewModal}
          handleClose={() => setOpenReviewModal(false)}
          vendorId={vendorId}
          userId={user._id ?? null}
        />
      )}
    </>
  );
};

export default EcomVendorDetailsCard;
